import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { Typography, Button } from '@quikr/ui';
import { Check } from '@quikr/ui/src/icons';
import RadioStyle from '../common/ReportAd/RadioStyle';

const Wrapper = styled.div`
  @media screen and (min-width: 768px) {
    margin: -6px;
  }
`;
const PromWrapper = styled.div`
  flex-direction: row-reverse;
`;
const PromItem = styled.div`
  width: calc(50% - 9px);
  border: 1px solid ${({ theme }) => theme.colors.Neutral[300]};
  border-top: 3px solid ${({ theme }) => theme.colors.Neutral[100]};
  @media screen and (max-width: 767px) {
    border-top: 1px solid ${({ theme }) => theme.colors.Neutral[300]};
    border-radius: 2px;
  }
  ${({ active }) =>
    active &&
    css`
      border-color: ${props => props.theme.colors.Primary};
      @media screen and (max-width: 767px) {
        border-color: ${props => props.theme.colors.Primary};
      }
    `}
`;

const PromHead = styled.div`
  border-bottom: 1px solid ${({ theme }) => theme.colors.Neutral[300]};
  @media screen and (min-width: 768px) {
    display: flex;
    align-items: center;
    height: 60px;
    padding: 0 8px;
    border: none;
  }
`;
const MobileWrap = styled.span`
  display: block;
  background: rgba(221, 221, 221, 0.2);
  padding: 11px 30px;
  @media screen and (min-width: 360px) {
    padding: 11px 45px;
  }
  @media screen and (min-width: 768px) {
    display: inline-flex;
    order: 1;
    flex: 1;
    align-items: center;
    background: transparent;
    padding: 0;
  }
`;
const Radio = styled.span`
  margin: 0 7px 0 0;
  &:before {
    content: '';
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: ${({ theme }) => theme.colors.TextGamma};
    position: absolute;
    top: 3px;
    left: 3px;
    display: none;
  }
  ${({ active }) =>
    active &&
    css`
      border-color: ${props => props.theme.colors.Primary};
      &:before {
        display: block;
        background: ${props => props.theme.colors.Primary};
      }
    `}
`;
const PromTitle = styled(Typography)`
  color: ${({ theme }) => theme.colors.TextBeta};
  @media screen and (max-width: 767px) {
    display: block;
    color: ${({ theme }) => theme.colors.TextAlpha};
    text-transform: uppercase;
    margin-bottom: 10px;
  }
`;
const Price = styled(Typography)`
  margin-left: auto;
`;
const PromBody = styled.ul`
  padding: 18px 10px 8px;
  @media screen and (max-width: 767px) {
    margin-top: 25px;
    background: ${({ theme }) => theme.colors.Neutral[500]};
    border: 1px dashed ${({ theme }) => theme.colors.Neutral[300]};
    border-radius: 10px;
    padding: 15px 10px 5px;
  }
  @media screen and (max-width: 359px) {
    padding: 10px 10px 0;
  }
  ${({ show }) =>
    !show
      ? css`
          @media screen and (max-width: 767px) {
            display: none;
          }
        `
      : css`
          display: none;
          @media screen and (max-width: 767px) {
            display: block;
          }
        `}
`;

const PromLi = styled(Typography)`
  align-items: flex-start;
  margin-bottom: 10px;
  color: ${({ theme }) => theme.colors.TextBeta};
  font-size: 14px;
  @media screen and (max-width: 359px) {
    margin-bottom: 6px;
  }
`;

const CheckIcon = styled(Check)`
  fill: ${({ theme }) => theme.colors.Secondary};
  flex: 0 0 20px;
  margin-right: 12px;
`;

const BtnWrapper = styled.div`
  padding: 30px 0 15px;
  @media screen and (max-width: 767px) {
    padding: 16px 0 0;
  }
`;

const renderBenefits = (benefits, showMobile) => {
  return (
    <PromBody show={showMobile}>
      {benefits.map((benefit, index) => {
        return (
          <PromLi tagName="li" className="dF" key={index}>
            <CheckIcon />
            {benefit}
          </PromLi>
        );
      })}
    </PromBody>
  );
};

const Promotion = ({ products, user, fireGa, getLinkRequest }) => {
  const [reqError, setreqError] = useState('');
  const getPrice = type => {
    return products.filter(option => option.type === type)[0].price;
  };
  const [promotion, setPromotion] = useState('VIP2');
  const [price, setPrice] = useState(getPrice('VIP2'));
  const selectPromotion = type => {
    setPromotion(type);
    setPrice(getPrice(type));
    setreqError('');
  };
  useEffect(() => {
    fireGa && fireGa('applyModal_paymentOptions_viewed');
  }, []);
  const handleSubmit = async e => {
    e.preventDefault();
    const formData = {
      user: {
        mobile: user.mobile,
        email: user.email
      },
      type: promotion
    };
    if (user.id) {
      formData.user.id = parseInt(user.id);
    }
    const response = await getLinkRequest({
      variables: { payLoad: formData }
    });
    const data = response.data;
    if (data.getPaymentLink && data.getPaymentLink.paymentUrl) {
      fireGa && fireGa('applyModal_paymentOptions_buyNow');
      window.location.href = data.getPaymentLink.paymentUrl;
    } else {
      setreqError('Something went wrong! Please try again later');
    }
  };
  return (
    <Wrapper>
      <RadioStyle />
      <Typography className="form__heading" tagName="p">
        {"You want a job fast, don't you? Choose from one of the packs below and find a job now!"}
      </Typography>
      {reqError && (
        <Typography className="form__error" tagName="p">
          {reqError}
        </Typography>
      )}
      <PromWrapper className="dF jcSB">
        {products.map(product => {
          return (
            <PromItem
              className="cP"
              active={promotion === product.type}
              key={product.type}
              onClick={() => selectPromotion(product.type)}
            >
              <PromHead className="taC">
                <MobileWrap>
                  <PromTitle tagName="span" modifiers={['bold', 'bt2']}>{`${
                    product.type === 'VIP2' ? 'Gold' : 'Silver'
                  } Candidate`}</PromTitle>
                  <Price tagName="span" modifiers={['medium', 'h3']}>
                    <span>₹</span>
                    {product.price}
                  </Price>
                </MobileWrap>
                <Radio className="radio radio_mobile pR" active={promotion === product.type} />
              </PromHead>
              {renderBenefits(product.benefits, false)}
            </PromItem>
          );
        })}
      </PromWrapper>
      {renderBenefits(products.filter(option => option.type === promotion)[0].benefits, true)}
      <BtnWrapper className="taC">
        <Button
          className="form__button"
          onClick={handleSubmit}
          btnType="primary"
          size="lg"
          type="button"
        >
          BUY NOW (₹{price})
        </Button>
      </BtnWrapper>
    </Wrapper>
  );
};

Promotion.propTypes = {
  user: PropTypes.object,
  products: PropTypes.array,
  fireGa: PropTypes.func,
  getLinkRequest: PropTypes.func
};

export default Promotion;
